module.exports = __webpack_public_path__ + "static/media/kavak-headset.0f8fa8f5.svg";